import { Component, OnInit } from '@angular/core';
import {SessionActivityModel} from '../../../../models/student/session.model';
import {SchoolAdminService} from '../../../../services/school/school-admin.service';
import {AdminSchoolService} from '../../../../services/admin/admin-school.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {GroupModel} from '../../../../models/school/group.model';
import {ModalService} from '../../../../shared/modals/modal/modal.service';
import {ErrorModel} from '../../../../models/shared/error.model';
import {SchoolGroupFilter} from '../../../../services/school/school-groups.service';

@Component({
  selector: 'app-evo-admin-school-groups',
  templateUrl: './evo-admin-school-groups.component.html',
  styleUrls: ['./evo-admin-school-groups.component.css']
})
export class EvoAdminSchoolGroupsComponent implements OnInit {

  interval = SessionActivityModel.SessionIntervals.Month;
  startDate = new Date(2024, 0, 1, 0, 0, 0, 0);
  endDate = new Date(2025, 10, 30, 0, 0, 0, 0);

  schoolId: string;
  filter = new SchoolGroupFilter();
  groups: GroupModel[] = [];
  hasMoreData = true;

  constructor(private schoolAdminSv: AdminSchoolService,
              private modalSv: ModalService,
              private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit() {

    this.route.parent.params.subscribe((params: Params) => {

      this.schoolId = params.schoolId;
      this.fetchSchools();

    });

  }

  fetchSchools() {

    this.filter.skip = this.groups.length;
    this.schoolAdminSv.fetchGroups(this.schoolId, this.filter).subscribe((groups) => {
      this.groups = this.groups.concat(groups);
      this.hasMoreData = this.groups.length % this.filter.limit === 0;
    }, (err: ErrorModel) => {
      this.modalSv.showTranslatedErrorModal(err);
    });

  }

  onCroupClicked(g: GroupModel) {
    this.router.navigate(['admin', 'schools', g.schoolId, 'groups', g._id, 'activity']);
  }

}
